import { render, staticRenderFns } from "./search-location-item.vue?vue&type=template&id=2d5cb59a"
import script from "./search-location-item.vue?vue&type=script&lang=js"
export * from "./search-location-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports